import * as React from 'react'

import { inject, observer } from 'mobx-react'

import { IProjectAddress } from '~/client/graph'
import { IWeatherBarForecast } from '~/client/src/shared/components/WeatherHourlyWidget/WeatherBarPresenter'
import WeatherDayPresenter, {
  IWeatherDayForecast,
} from '~/client/src/shared/components/WeatherPresenters/WeatherDayPresenter'
import WeatherUnits from '~/client/src/shared/enums/WeatherUnits'
import WeatherForecastInfo from '~/client/src/shared/models/WeatherInfo'
import WeatherForecastsStore from '~/client/src/shared/stores/domain/WeatherForecasts.store'
import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

import './DetailedWeatherWidget.scss'

interface IProps {
  startDate: Date | number
  todayForecast: WeatherForecastInfo
  temperatureUnit: string
  windSpeedUnit: string
  projectAddress: IProjectAddress

  projectDateStore?: ProjectDateStore
  weatherForecastsStore?: WeatherForecastsStore
}

@inject('projectDateStore', 'weatherForecastsStore')
@observer
export default class WeatherDayWidget extends React.Component<IProps> {
  public render() {
    const {
      todayForecast,
      projectAddress,
      projectDateStore,
      startDate,
      weatherForecastsStore,
    } = this.props

    const units =
      weatherForecastsStore.weatherUnits === WeatherUnits.Imperial
        ? 'imperial'
        : 'metric'

    // Transform WeatherForecastInfo to presenter format
    const presenterForecast: IWeatherDayForecast = {
      temperature: todayForecast.currentTemp,
      minTemperature: todayForecast.minTemp,
      maxTemperature: todayForecast.maxTemp,
      humidity: todayForecast.humidity,
      windSpeed: todayForecast.windSpeed,
      windDegree: todayForecast.windDegree,
      probabilityOfPrecipitation: todayForecast.probabilityOfPrecipitation,
      amountOfPrecipitation: todayForecast.amountOfPrecipitation,
      weatherIconCode: todayForecast.weatherIconCode,
      weatherDescription: todayForecast.weatherDescription,
    }

    // Get hourly forecasts and transform them
    const hourlyForecasts =
      weatherForecastsStore.getHourlyForecastForDay(startDate)
    const presenterHourlyForecasts: IWeatherBarForecast[] = hourlyForecasts.map(
      f => ({
        time: f.date,
        temperature: f.currentTemp,
        weatherIconCode: f.weatherIconCode,
        windSpeed: f.windSpeed,
        windDegree: f.windDegree,
        probabilityOfPrecipitation: f.probabilityOfPrecipitation,
        amountOfPrecipitation: f.amountOfPrecipitation,
      }),
    )

    const formattedDate =
      projectDateStore?.getMonthDayAndYearToDisplay(startDate) || ''

    return (
      <WeatherDayPresenter
        forecast={presenterForecast}
        hourlyForecasts={presenterHourlyForecasts}
        projectAddress={projectAddress}
        units={units}
        formattedDate={formattedDate}
        formatTime={this.formatTime}
      />
    )
  }

  private formatTime = (timestamp: number): [string, string] => {
    const timeStr = this.props.projectDateStore.getTimeToDisplay(timestamp)
    const [time, format] = timeStr.split(' ')
    return [time, format || '']
  }
}
